import React, { useState } from "react";

const LoginToWordPressButton = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const handleLogin = async () => {
        setLoading(true);
        setError(null);
        window.location.href = "https://bizcard.utusanrajasehari.com/direct/login?code=426c1850-6b5d-4b5b-851e-8ac27de9b8e4"; // Redirect to WP Admin
    };
    return (
        <div>
            <button
                onClick={handleLogin}
                disabled={loading}
                style={{
                    padding: "10px 20px",
                    backgroundColor: "#0073aa",
                    color: "#fff",
                    border: "none",
                    borderRadius: "5px",
                    cursor: loading ? "not-allowed" : "pointer",
                }}
            >
                {loading ? "Logging in..." : "Login to Bizcard"}
            </button>

            {error && <p style={{ color: "pink" }}>{error}</p>}
        </div>
    );
};

export default LoginToWordPressButton;
